import api from '../client';

/**
 * Service pour la gestion des notifications
 */
const notificationService = {
  /**
   * Récupérer la liste des notifications
   * @param {Object} params - Paramètres (page, limit, read)
   * @returns {Promise} Liste des notifications
   */
  getNotifications: async (params = {}) => {
    try {
      const response = await api.get('/notifications', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Récupérer le nombre de notifications non lues
   * @returns {Promise} Nombre de notifications non lues
   */
  getUnreadCount: async () => {
    try {
      const response = await api.get('/notifications/unread-count');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Marquer une notification comme lue
   * @param {string} id - ID de la notification
   * @returns {Promise} Notification mise à jour
   */
  markAsRead: async (id) => {
    try {
      const response = await api.patch(`/notifications/${id}/read`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Marquer toutes les notifications comme lues
   * @returns {Promise} Confirmation
   */
  markAllAsRead: async () => {
    try {
      const response = await api.post('/notifications/mark-all-read');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Supprimer une notification
   * @param {string} id - ID de la notification
   * @returns {Promise} Confirmation de suppression
   */
  deleteNotification: async (id) => {
    try {
      const response = await api.delete(`/notifications/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Supprimer toutes les notifications lues
   * @returns {Promise} Confirmation
   */
  deleteAllRead: async () => {
    try {
      const response = await api.delete('/notifications/read');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default notificationService;
